export default __webpack_public_path__ + "static/media/bw.5d02b900.svg";